<template>
    <div class="desktop-main">
        <div class="admin-body">
            <el-form ref="form" :model="dialogTaskInfo.taskInfo" label-width="80px">
                <el-form-item label="价格">
                    <!-- <el-input v-model="dialogTaskInfo.taskInfo.handPrice"></el-input> -->
                    <el-input-number v-model="dialogTaskInfo.taskInfo.handPrice" :precision="2" :step="0.01" :max="10000" :min="0.01"></el-input-number>
                </el-form-item>
                <el-form-item label="广告图">
                    <el-image
                        v-if="dialogTaskInfo.taskInfo.adPicUrl"
                        style="width: 100px;"
                        :src="dialogTaskInfo.taskInfo.adPicUrl"
                        fit="fit"
                        :preview-src-list="[dialogTaskInfo.taskInfo.adPicUrl]">
                    </el-image>
                    <el-upload
                        class="upload-demo"
                        :action="uploadUrl"
                        :headers="uploadHeaders"
                        :on-remove="handleRemoveByAdPic"
                        :limit="1"
                        :on-exceed="handleExceedByAdPic"
                        :on-success="handleSuccessByAdPic"
                        :file-list="adFileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，宽5160，高1200</div>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="newUpdateTaskClick">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import NProgress from 'nprogress'
import { queryHandDictDetailApi, saveHandDictDetailApi } from '@/api/api';

    export default {
        components: { 
        },
        data() {
            return {
                dialogTaskInfo: {
                    taskInfo: {
                        handPrice: '',
                        adPicUrl: '',
                    }
                },
                adminType: 2,
                // 图片上传
                uploadUrl: process.env.ENV_HOST + "/admin/commonFile/uploadPic",
                uploadHeaders: {},
                adFileList: [],
            }
        },
        filters: {
        },
        methods: {
            init(){
                const orgPath = this.$route.path
                // this.$router.push({ path: '/task_mgr/task_sub_mgr', query:{taskId:1, orgPath: orgPath} });
                let user = sessionStorage.getItem('user');
                this.adminType = JSON.parse(user).adminType
                this.uploadHeaders = {
                    token: sessionStorage.getItem('token'),
                    identity: 2
                }
                this.queryTaskClick()                
            },
            queryTaskClick(){
                // 查询
                NProgress.start();
                let params = {}
                queryHandDictDetailApi(params).then(data => {
                    this.dialogTaskInfo.taskInfo.handPrice = data.result.handPrice
                    this.dialogTaskInfo.taskInfo.adPicUrl = data.result.adPicUrl
                    if (data.result.adPicUrl) {
                        this.adFileList = [{
                            name: "广告图",
                            url: data.result.adPicUrl
                        }]
                    }
                    NProgress.done();
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
            // deleteTaskClick(row){
            //     // 删除
            //     NProgress.start();
            //     let params = {
            //         ...row
            //     }
            //     deleteTaskByIdApi(params).then(data => {
            //         this.$message.success("删除成功")
                    
            //         this.resetParamsClick()
            //         this.queryTaskClick()
            //         NProgress.done();
            //     }).catch(error => {
            //         this.$message.error(error.message);
            //         NProgress.done();
            //     });
            // },
            changePage(index){
                console.log("翻页", index);
                this.tableData.pageNum += index
                this.queryTaskClick()
            },
            handleCurrentChange(data){
                this.tableData.pageNum = data
                this.queryTaskClick()
            },
            newUpdateTaskClick(){
                // 更新
                NProgress.start();
                let params = {
                    ...this.dialogTaskInfo.taskInfo
                }
                saveHandDictDetailApi(params).then(data => {
                    this.$message.success("更新成功")
                    NProgress.done();
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
            handleRemoveByAdPic(file, fileList) {
                console.log(file);
                this.dialogTaskInfo.taskInfo.adPicUrl = ''
            },
            handleExceedByAdPic(files, fileList) {
                // this.$message.warning(`当前限制选择【1】个文件，本次已经选择了【${files.length}】个文件，共选择了【${files.length + fileList.length}】个文件`);
                this.$message.warning(`当前限制选择【1】张图片，请删除已存在的图片后重新上传`);
            },
            handleSuccessByAdPic(response, file, fileList){
                if (response.status.code != 200) {
                    this.$message.error("上传失败，请重新上传");
                    return
                }
                console.log(response, file, fileList);
                let result = response.result
                this.dialogTaskInfo.taskInfo.adPicUrl = result.url
            },
        },
        mounted() {
            this.init()
        }
    }

</script>

<style lang="scss" scoped>
.desktop-main {
    width: calc(100% - 40px);
    padding: 20px;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
}
.upload-demo {
    max-width: 500px;
}
</style>


// WEBPACK FOOTER //
// dict_mgr.vue?530c507a